//catagory component
import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Badge } from 'react-bootstrap';
import CategoryService from '../services/category.service';
import Form from 'react-bootstrap/Form';
import AnimateHeight from 'react-animate-height';
import { ChevronDown, ChevronUp, ArrowCounterclockwise } from 'react-bootstrap-icons';
import LogoButton from './LogoButton';


const CategoryList = (props) => {
    const [categories, setCategories] = useState([]);
    const [allChecks, setAllChecks] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const [height, setHeight] = useState(0);
    const [localCategories, setLocalCategories] = useState([]);

    // Subsite-specific category override state
    const [editMode, setEditMode] = useState('subsite'); // 'global' or 'subsite'
    const [hasSubsiteOverrides, setHasSubsiteOverrides] = useState(false);
    const [subsiteChecks, setSubsiteChecks] = useState([]);
    const [subsiteCategories, setSubsiteCategories] = useState([]);


    const toggleExpansion = () => {
        setIsExpanded(!isExpanded);
        setHeight(isExpanded ? 0 : 'auto');
    };

    useEffect(() => {
        const fetchData = async () => {
            // fetch all ignite categories
            const allCategories = await CategoryService.getIgniteCategories();
            setCategories(allCategories);

            // Set up global category checks based on style's default categories
            var newChecks = [];
            let value = false;
            for (let i = 0; i < allCategories.length; i++) {
                value = false;
                if(props.style) {
                    for (let j = 0; j < props.style.ignite_categories.length; j++) {
                        if (allCategories[i].id === props.style.ignite_categories[j].id) {
                            value = true;
                        }
                    }
                }
                newChecks.push(value);
            }
            setAllChecks(newChecks);

            // Fetch subsite-specific category overrides
            if (props.style) {
                try {
                    const subsiteData = await CategoryService.getSubsiteStyleCategories(props.style.id);
                    setHasSubsiteOverrides(subsiteData.hasOverrides);

                    // Set up subsite category checks
                    const subsiteCatIds = subsiteData.categories.map(c => c.id);
                    const subsiteNewChecks = allCategories.map(c => subsiteCatIds.includes(c.id));
                    setSubsiteChecks(subsiteNewChecks);
                    setSubsiteCategories(subsiteData.categories);

                    // Use subsite categories for display if overrides exist
                    if (subsiteData.hasOverrides) {
                        setLocalCategories(subsiteData.categories);
                    } else {
                        setLocalCategories(props.style.ignite_categories);
                    }
                } catch (e) {
                    console.error("Error fetching subsite style categories:", e);
                    setLocalCategories(props.style.ignite_categories);
                }
            }
        }
        if (props.editEnabled) {
            fetchData();
        } else if(props.style) {
            setLocalCategories(props.style.ignite_categories);
        }

    }, [props.editEnabled, props.style]);

    const updateCategory = async (e, idx, category) => {
        // Always call the parent callback if provided (for AdminAddProduct tracking)
        if (props.updateIgniteCategoryForStyle) {
            props.updateIgniteCategoryForStyle(category.id, e.target.checked);
        }

        if (editMode === 'global') {
            // Update global style categories (existing behavior)
            var newChecks = [...allChecks];
            newChecks[idx] = !newChecks[idx];
            setAllChecks(newChecks);
        } else {
            // Update subsite-specific categories
            if (props.style) {
                await CategoryService.toggleSubsiteStyleCategory(props.style.id, category.id, e.target.checked);
            }
            var newSubsiteChecks = [...subsiteChecks];
            newSubsiteChecks[idx] = !newSubsiteChecks[idx];
            setSubsiteChecks(newSubsiteChecks);
            setHasSubsiteOverrides(true);

            // Update local categories for display
            var newCategories = [...subsiteCategories];
            if (e.target.checked) {
                newCategories.push(category);
            } else {
                newCategories = newCategories.filter(c => c.id !== category.id);
            }
            setSubsiteCategories(newCategories);
            setLocalCategories(newCategories);
        }
    }

    const clearSubsiteOverrides = async () => {
        if (window.confirm("Reset to default categories? This will remove all subsite-specific category overrides for this product.")) {
            await CategoryService.clearSubsiteStyleCategories(props.style.id);
            setHasSubsiteOverrides(false);
            setSubsiteChecks([...allChecks]);
            setSubsiteCategories(props.style.ignite_categories);
            setLocalCategories(props.style.ignite_categories);
        }
    }

    const currentChecks = editMode === 'global' ? allChecks : subsiteChecks;

    return (
        <div>
            <div style={{ margin: 0, padding: 0 }}><span className="sectionTitle">CATEGORIES</span>
                {hasSubsiteOverrides && <Badge bg="info" style={{ marginLeft: 8 }}>Subsite Override</Badge>}
                {props.editEnabled ? (
                    <>
                        {isExpanded ?
                            <LogoButton style={{ color: "blue" }} size="20" Icon={ChevronUp} tooltip="Hide Categories" onClick={toggleExpansion} /> :
                            <LogoButton style={{ color: "blue" }} size="20" Icon={ChevronDown} tooltip="Expand Categories" onClick={toggleExpansion} />
                        }
                    </>
                ) : null}
            </div>
            <Row>
                <Col>
                    <ul>
                        {localCategories.map((category) => (
                            <li key={category.id}>{category.categoryName}</li>
                        ))}
                    </ul>
                </Col>
            </Row>
            <AnimateHeight duration={500} height={height}>
                <Row style={{ border: "1px solid #CCCCCC", padding: 10 }}>
                    <Col>
                        <div style={{ marginBottom: 10 }}>
                            <Form.Check
                                inline
                                type="radio"
                                label="Edit for this subsite only"
                                name="editMode"
                                checked={editMode === 'subsite'}
                                onChange={() => setEditMode('subsite')}
                            />
                            {props.isSuperAdmin && (
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Edit global defaults"
                                    name="editMode"
                                    checked={editMode === 'global'}
                                    onChange={() => setEditMode('global')}
                                />
                            )}
                            {hasSubsiteOverrides && editMode === 'subsite' && (
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={clearSubsiteOverrides}
                                    style={{ marginLeft: 10 }}
                                >
                                    <ArrowCounterclockwise /> Reset to Defaults
                                </Button>
                            )}
                        </div>
                        <div style={{ fontSize: 12, color: '#666', marginBottom: 10 }}>
                            {editMode === 'subsite'
                                ? "Changes will only affect this subsite's catalog."
                                : "Changes will affect all subsites using default categories."}
                        </div>
                        {categories.map((category, index) => (
                            <Form.Group key={category.id} className="mb-3" controlId={`category-${category.id}`}>
                                <Form.Check
                                    type="checkbox"
                                    label={category.categoryName}
                                    checked={currentChecks[index]}
                                    onClick={(e) => updateCategory(e, index, category)}
                                />
                            </Form.Group>
                        ))}
                    </Col>
                </Row>
            </AnimateHeight>
        </div>
    );
};
export default CategoryList;
